import {
  SEARCH_RECIPIENT_COUNT_PEOPLE_START,
  SEARCH_RECIPIENT_COUNT_PEOPLE_SUCCESS,
  SEARCH_RECIPIENT_COUNT_PEOPLE_FAIL,
  SEARCH_RECIPIENT_EXPAND_RECIPIENT_START,
  SEARCH_RECIPIENT_EXPAND_RECIPIENT_SUCCESS,
  SEARCH_RECIPIENT_EXPAND_RECIPIENT_FAIL,
  SEARCH_RECIPIENT_GET_ALL_START,
  SEARCH_RECIPIENT_GET_ALL_SUCCESS,
  SEARCH_RECIPIENT_GET_ALL_FAIL,
} from 'actions/recipientSearch/constant';

export const defaultState = {
  count: {
    inProgress: false,
    error: false,
    value: null,
    lastRequestTime: null,
  },
  expand: {
    inProgress: false,
    error: false,
  },
  getAll: {
    inProgress: false,
    error: false,
  },
};

export default function recipientMultiSelect(state = defaultState, action) {
  switch (action.type) {
    case SEARCH_RECIPIENT_COUNT_PEOPLE_START: {
      return {
        ...state,
        count: {
          ...state.count,
          error: false,
          inProgress: true,
          lastRequestTime: action.payload.requestTime,
        },
      };
    }
    case SEARCH_RECIPIENT_COUNT_PEOPLE_SUCCESS: {
      if (action.payload.requestTime >= state.count.lastRequestTime) {
        return {
          ...state,
          count: {
            ...state.count,
            error: false,
            inProgress: false,
            value: action.payload.count,
          },
        };
      }
      return state;
    }
    case SEARCH_RECIPIENT_COUNT_PEOPLE_FAIL: {
      if (action.initialPayload.requestTime >= state.count.lastRequestTime) {
        return {
          ...state,
          count: {
            ...state.count,
            error: true,
            inProgress: false,
          },
        };
      }
      return state;
    }
    case SEARCH_RECIPIENT_EXPAND_RECIPIENT_START: {
      return {
        ...state,
        expand: {
          inProgress: true,
          error: false,
        },
      };
    }
    case SEARCH_RECIPIENT_EXPAND_RECIPIENT_SUCCESS: {
      return {
        ...state,
        expand: defaultState.expand,
      };
    }
    case SEARCH_RECIPIENT_EXPAND_RECIPIENT_FAIL: {
      return {
        ...state,
        expand: {
          inProgress: false,
          error: true,
        },
      };
    }
    case SEARCH_RECIPIENT_GET_ALL_START: {
      return {
        ...state,
        getAll: {
          inProgress: true,
          error: false,
        },
      };
    }
    case SEARCH_RECIPIENT_GET_ALL_SUCCESS: {
      return {
        ...state,
        getAll: defaultState.getAll,
      };
    }
    case SEARCH_RECIPIENT_GET_ALL_FAIL: {
      return {
        ...state,
        getAll: {
          inProgress: false,
          error: true,
        },
      };
    }
    default:
      return state;
  }
}
